<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">站点</span>
        <el-autocomplete
          v-model="parameterNames.channel_code_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          style="width: 250px"
          @focus="current = '站点'"
          @select="handleSelect"
          @clear="
            ;(parameter.channel_code = null),
              (parameterNames.channel_code_name = null)
          "
        />
      </div>
      <div class="item">
        <span class="item_title">平台</span>
        <el-autocomplete
          v-model="parameterNames.platform_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '平台'"
          @select="handleSelect"
          @clear="platform_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="release_group_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="pitcher_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书籍归属'"
          @clear="book_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书名'"
          @clear="alias_book_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放位置'"
          @clear="position_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-search"
        @click="search()"
      >搜索</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-bottom"
        @click="reportExport"
      >导出总计报表</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        border
        style="width: 100%"
      >
        <el-table-column prop="channel_date" label="日期范围" width="150" />
        <el-table-column prop="release_group_name" label="投放组" width="120" />
        <el-table-column prop="pitcher_name" label="投手姓名" />
        <el-table-column prop="platform_name" label="书城平台" width="120" />
        <el-table-column prop="position_name" label="投放位置" />
        <el-table-column prop="belong_name" label="归属书籍" width="120" />
        <el-table-column prop="novel_name" label="书名" width="120" />
        <el-table-column prop="channel_names" label="站点" width="150">
          <template scope="scope">
            <ExpandClose :my-values="JSON.parse(scope.row.channel_names)" />
          </template>
        </el-table-column>
        <el-table-column prop="roi_standard" label="ROI标准" />
        <el-table-column prop="compliance_rate" label="ROI达标率" width="120">
          <template scope="scope"> {{ scope.row.compliance_rate }}% </template>
        </el-table-column>
        <el-table-column prop="consume" label="总消耗" />
        <el-table-column
          prop="new_user_recharge_commission"
          label="新用户充值（扣除佣金）"
          width="180"
        />
        <el-table-column prop="new_user_roi" label="新用户roi" width="120">
          <template scope="scope">
            <span
              style="color: red; font-weight: bold"
            >{{ scope.row.new_user_roi }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_recharge_commission"
          label="累积充值（扣除佣金）"
          width="180"
        />
        <el-table-column prop="today_back" label="总充值roi" width="120">
          <template scope="scope"> {{ scope.row.today_back }}% </template>
        </el-table-column>
        <el-table-column
          prop="payment_growth_rate"
          label="付费增长率"
          width="120"
        >
          <template
            scope="scope"
          >{{ scope.row.payment_growth_rate }}%</template>
        </el-table-column>
        <el-table-column prop="merits" label="有效绩效" width="120" />
        <!-- <el-table-column prop="scan_follow_count" label="企微客服人数" width="120" />
        <el-table-column prop="scan_follow_cost" label="企微客服成本" width="120" />
        <el-table-column prop="from_follow_count" label="公众号关注人数" width="140" />
        <el-table-column prop="from_follow_cost" label="公众号关注成本" width="140" /> -->
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import {
  getTotalReportListNovelSite,
  getPlatform,
  getReleaseGroupListNovel,
  getListOfPitchersInTheLaunchGroupNovel,
  getTitleListNovel,
  getBookOwnershipListNovel,
  dropLocationListNovel,
  modifyConsumptionNovelSite,
  exportTotalReportNovleSite,
  getTheListOfOfficialAccountNovelSite
} from '@/api/newLaunchGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose
    /* Details */
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        channel_code: null,
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null
      },
      parameterNames: {
        channel_code: null, // 渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null
      },
      current: null,
      date: [],
      activeItem: null,
      activeText: null,
      drawerItem: {},
      hasSearched: []
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      if (
        Object.prototype.toString.call(ob1.channel_code) === '[object Object]'
      ) {
        console.log('进来了')
        ob1.channel_code = ob1.channel_code.address
      }
      const data = await getTotalReportListNovelSite({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        投放组: 'release_group_name',
        投手: 'user_name',
        书籍归属: 'book_name',
        书名: 'novel_name',
        投放位置: 'position_name',
        站点: 'channel_code_name',
        平台: 'platform_name'
      }

      switch (this.current) {
        case '投放组':
          currentFunc = getReleaseGroupListNovel
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroupNovel
          break
        case '书名':
          currentFunc = getTitleListNovel
          break
        case '书籍归属':
          currentFunc = getBookOwnershipListNovel
          break
        case '投放位置':
          currentFunc = dropLocationListNovel
          break
        case '站点':
          currentFunc = getTheListOfOfficialAccountNovelSite
          break
        case '平台':
          currentFunc = getPlatform
          break
      }
      if (!currentFunc) {
        return
      }
      if (
        (this.current === '投手' && !this.parameter.release_group_id) ||
        (this.current === '书名' && !this.parameter.book_id)
      ) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          运营者: '请先选运营组，才能选运营者',
          书名: '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      let result = null
      console.log('item:', queryString)
      if (this.current === '站点' && queryString !== null) {
        result = queryString.replace(/\([^()]+\)/g, '')
      }
      if (this.current === '站点' && this.hasSearched.length !== 0) {
        var restaurants = this.hasSearched
        var results = result
          ? restaurants.filter(this.createFilter(result))
          : restaurants
        // 调用 callback 返回建议列表的数据
        console.log('results:', results)
        // cb(results)
        cb(
          results.map((item) => {
            return item
          })
        )
        return
      }
      const data = await currentFunc({
        name: this.current !== '站点' ? queryString : null,
        channel_name: this.current === '站点' ? result : null,
        group_id:
          this.current === '投手'
            ? this.parameter.release_group_id.address
            : null,
        book_belong_id: this.parameter.book_id
          ? this.parameter.book_id.address
          : null,
        type: this.current === '投放组' ? 2 : null
      })
      cb(
        data.data.list.map((item) => {
          if (this.current === '站点') {
            this.hasSearched.push({
              value:
                this.current === '站点'
                  ? `${item.channel_name}(${item.platform_str})`
                  : this.current === '平台'
                    ? item.name
                    : item[obj[this.current]],
              address: this.current === '站点' ? item.channel_code : item.id
            })
          }
          return {
            value:
              this.current === '站点'
                ? `${item.channel_name}(${item.platform_str})`
                : this.current === '平台'
                  ? item.name
                  : item[obj[this.current]],
            address: this.current === '站点' ? item.channel_code : item.id
          }
        })
      )
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value
          .toLowerCase()
          .includes(queryString.toLowerCase())
      }
    },
    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
        case '站点':
          this.parameter.channel_code = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        channel_code: 'channel_code_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        console.log('key:', key)
        if (
          this.parameter[key] &&
          this.parameter[key].value === this.parameterNames[obj[key]] &&
          key !== 'page' &&
          key !== 'pageSize'
        ) {
          obj1[key] = this.parameter[key].address
        } else if (
          key !== 'page' &&
          key !== 'pageSize' &&
          key !== 'channel_code'
        ) {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })

      value === '导出' || this.getDataList(obj1)
      return obj1
    },

    // 重置
    reset(value) {
      this.parameter = {
        page: 1,
        pageSize: 10,
        channel_code: null,
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null,
        platform_id: null
      }
      this.parameterNames = {
        channel_code: null, // 渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null,
        platform_name: null
      }
      this.date = []
      this.current = null
      this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportTotalReportNovleSite({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },

    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await modifyConsumptionNovelSite({
            id: this.activeItem.id,
            consume: this.activeText
          })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content {
  .item {
    display: flex;
    align-items: center;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
    .item_input {
      width: 200px;
    }
  }
}

.powder {
  background: rgb(248, 216, 216);
}
.green {
  background: rgb(52, 229, 54);
}
.yellow {
  background: rgb(255, 247, 173);
}
.blue {
  background: rgb(158, 211, 252);
}
.red {
  background: #ffa500;
}
.magRig {
  margin-right: 10px;
}
.magLfte {
  margin-left: 10px;
}
.chong {
  display: inline-block;
  width: 13px;
  height: 86%;
  margin-left: 6px;
}
.mybox {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
</style>

<style>
.publicItems .el-dialog {
  margin-top: 6vh !important;
}
</style>
